import { Stack } from "@mui/material";
import RefreshGridButton from "./RefreshGridButton.tsx";

interface PreviewActionsProps {
  onRefresh: () => void;
  ChangePreviewModeButton?: React.ReactNode;
  EditingHistory?: React.ReactNode;
}

export default function PreviewActions({ onRefresh, ChangePreviewModeButton, EditingHistory }: PreviewActionsProps) {
  return (
    <Stack direction="row" useFlexGap spacing={1.5}>
      {EditingHistory}
      <Stack direction="row" useFlexGap spacing={1}>
        <RefreshGridButton onRefresh={onRefresh} />
        {ChangePreviewModeButton}
      </Stack>
    </Stack>
  );
}
